import Jslog from './Jslog';
// initialize standard tracking
var jslog = new Jslog();
export { jslog, Jslog };
//# sourceMappingURL=index.js.map